import React from 'react';
import {t} from '@lingui/core/macro';

import {ICity} from 'entities/location';
import {cityAPI} from 'features/admin/api/cityAPI';

import AdminCrudRow from '../AdminList/AdminCrudRow/AdminCrudRow';
import CitiesModal from './CitiesModal';

interface ICitiesRowProps {
    item: ICity;
}

const CitiesRow: React.FC<ICitiesRowProps> = ({item}) => (
    <AdminCrudRow
        item={item}
        name={item.name}
        EditModal={CitiesModal}
        useDeleteMutation={cityAPI.useDeleteCityMutation}
        deleteTexts={{
            header: t`Удаление города`,
            title: t`Вы уверены, что хотите удалить город`,
            hint: t`Все локации города тоже будут удалены.`,
            success: t`Город удалён`,
        }}
    >
        <td>{item?.id}</td>
        <td>{item?.name}</td>
        <td>{item?.country?.name}</td>
        <td>{item?.country?.zone?.name}</td>
    </AdminCrudRow>
);

export default CitiesRow;
